<mat-card class="summary-card" [ngClass]="'color-' + color" [routerLink]="routerLink">
    <mat-card-header>
        <div class="card-icon">
            <mat-icon>{{ icon }}</mat-icon>
        </div>
        <div class="card-content">
            <div class="card-value">
                <span class="unit">{{ unit }}</span>
                <span class="number">{{ value }}</span>
            </div>
            <p class="card-title">{{ title }}</p>
            <div class="card-trend" *ngIf="trend">
                <span [ngClass]="trend.isPositive ? 'trend-positive' : 'trend-negative'">
                    <mat-icon>{{ trend.isPositive ? 'trending_up' : 'trending_down' }}</mat-icon>
                    {{ trend.value }}%
                </span>
            </div>
        </div>
    </mat-card-header>
</mat-card>